module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_muacevic_sm-b2ada77498709057d121b5b4c3b3e42a.png";